import React, { useRef, useState } from 'react';
import InfoIcon from '@mui/icons-material/Info';
import { useTheme } from '@mui/material';
import UniversalTooltip from './UniversalTooltip'; // tu tooltip nuevo
import PriceTooltipSummary from './PriceTooltipSummary';

const PriceInfoIcon = ({
  price,
  total_nights,
  total_passangers,
  business_types,
}) => {
  const theme = useTheme();
  const iconRef = useRef(null);
  const [openTooltip, setOpenTooltip] = useState(false);

  return (
    <>
      <InfoIcon
        ref={iconRef}
        style={{
          color: theme.tertiary,
          width: '1.2rem',
          height: '1.2rem',
          marginLeft: '5px',
          cursor: 'pointer',
        }}
        onMouseEnter={() => setOpenTooltip(true)}
        onMouseLeave={() => setOpenTooltip(false)}
        onClick={() => setOpenTooltip(prev => !prev)}
      />

      <UniversalTooltip
        anchorRef={iconRef}
        open={openTooltip}
        onClose={() => setOpenTooltip(false)}
        offset={{ x: 15, y: 15 }}
      >
        <PriceTooltipSummary
          {...{
            price,
            total_nights,
            total_passangers,
            business_types,
          }}
        />
      </UniversalTooltip>
    </>
  );
};

export default PriceInfoIcon;
